import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export interface StatusConfig {
  label: string;
  className: string;
}

interface StatusBadgeProps {
  status: string;
  config: Record<string, StatusConfig>;
  fallback?: StatusConfig;
  className?: string;
}

const defaultFallback: StatusConfig = {
  label: "غير معروف",
  className: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({
  status,
  config,
  fallback = defaultFallback,
  className,
}: StatusBadgeProps) {
  const entry = config[status] ?? fallback;

  return (
    <Badge
      variant="outline"
      className={cn("font-medium", entry.className, className)}
    >
      {entry.label}
    </Badge>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const USER_STATUS_CONFIG: Record<string, StatusConfig> = {
  active: {
    label: "نشط",
    className: "bg-primary/10 text-primary border-primary/20",
  },
  inactive: {
    label: "غير نشط",
    className: "bg-muted text-muted-foreground border-border",
  },
};

// eslint-disable-next-line react-refresh/only-export-components
export const CONTENT_STATUS_CONFIG: Record<string, StatusConfig> = {
  published: {
    label: "منشور",
    className: "bg-primary/10 text-primary border-primary/20",
  },
  draft: {
    label: "مسودة",
    className: "bg-secondary/30 text-secondary-foreground border-secondary/40",
  },
  review: {
    label: "قيد المراجعة",
    className: "bg-accent/10 text-accent border-accent/20",
  },
};
